<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="finGLReport-main">
    <div class="content-container">
      <div class="left-container" resizable>
        <div class="filter-container" style="flex-grow: 1">
          <div style="font-weight: bold; margin-bottom: 2px; font-size: 0.85rem">Report Filters</div>
          <Dropdown
            placeholder="Report Type"
            :items="reportType"
            itemKey="rpt"
            :selectedObject.sync="selectedReport"
            :isRequired="true"
            :errorMessage.sync="SelectedReportErrMsg"
            @selected="reportSelected"
            style="margin-bottom: 8px"
          />

          <div v-if="selectedReport" class="filter-options">
            <BoxContainer title="By Fyear - Period">
              <Dropdown
                placeholder="FYear"
                :items="fYearList"
                itemKey="fyear"
                :selectedObject.sync="selectedFYear"
                @selected="fYearSelected"
                :errorMessage.sync="selectedFyearErrMsg"
                :isRequired="true"
              />
              <Dropdown
                placeholder="Period"
                :items="periodList"
                itemKey="period"
                :selectedObject.sync="selectedPeriod"
                @selected="periodSelected"
                :errorMessage.sync="selectedPeriodErrMsg"
                :isRequired="true"
                :isDisabled="rptShowCompareMonth"
              />
            </BoxContainer>
            <BoxContainer v-if="rptShowInclThisYear" title="Include This Year">
              <CheckBox
                v-if="rptShowInclThisMonth"
                title="Include This Month"
                :isChecked.sync="inclThisMonth"
                @checkBoxClicked="inclThisMonthClicked"
              />
              <CheckBox
                title="Include Previous Month"
                :isChecked.sync="inclPrevMonth"
                :isDisabled="selectedPeriod && selectedPeriod['period'] == '1'"
              />
            </BoxContainer>
            <BoxContainer v-if="rptShowInclPrevYear" title="Include Previous Year">
              <CheckBox
                v-if="rptShowInclPrevYearMonth"
                title="Include This Month"
                :isChecked.sync="inclPrevYearMonth"
              />
              <CheckBox title="Include YTD" :isChecked.sync="inclPrevYearYTD" />
            </BoxContainer>
            <BoxContainer v-if="rptShowCompareMonth" title="Month">
              <div style="display: flex; flex-direction: row; gap: 4px">
                <Dropdown
                  placeholder="From"
                  :items="periodList"
                  itemKey="period"
                  :selectedObject.sync="selectedMonthFrom"
                  :errorMessage.sync="selectedMonthFromErrMsg"
                  :isRequired="true"
                />
                <Dropdown
                  placeholder="To"
                  :items="periodList"
                  itemKey="period"
                  :selectedObject.sync="selectedMonthTo"
                  :errorMessage.sync="selectedMonthToErrMsg"
                  :isRequired="true"
                />
              </div>
            </BoxContainer>
            <CheckBox v-if="rptShowSubAcc" title="Show Sub Account" :isChecked.sync="showSubAcc" />
            <CheckBox v-if="rptShowPercentage" title="Show Percentage" :isChecked.sync="showPercentage" />
            <CheckBox
              v-if="rptShowZeroGLAcc"
              title="Show GL Accounts with Zero Amounts"
              :isChecked.sync="showZerolizeFigure"
            />
          </div>
          <Button @click="refreshClicked" :disabled="!selectedReport" class="mb-1">Refresh</Button>
        </div>
        <div class="filter-container" style="flex-shrink: 0">
          <div style="font-weight: bold; margin-bottom: 2px; font-size: 0.85rem">Active Filters</div>
          <Input placeholder="Report Type" :inputValue.sync="injectedReportName" :isDisabled="true" />
          <Input
            v-if="injectedFyearPeriod != ''"
            placeholder="Fyear - Period"
            :inputValue.sync="injectedFyearPeriod"
            :isDisabled="true"
          />
          <Input
            v-if="injectedMonth != ''"
            placeholder="Fyear - Compare Month From To"
            :inputValue.sync="injectedMonth"
            :isDisabled="true"
          />
          <Input
            v-if="injectedThisYear != ''"
            placeholder="Include This Year"
            :inputValue.sync="injectedThisYear"
            :isDisabled="true"
          />
          <Input
            v-if="injectedPreviousYear"
            placeholder="Include Previous Year"
            :inputValue.sync="injectedPreviousYear"
            :isDisabled="true"
          />
          <Input v-if="injectedFilters" placeholder="Show" :inputValue.sync="injectedFilters" :isDisabled="true" />
        </div>
      </div>
      <div class="table-container">
        <TableBox
          v-if="reportData.length > 0"
          ref="reportTB"
          :title="reportTableName"
          :tableData="reportData"
          :dataType.sync="reportTableDataType"
          :maxSelection="0"
          :tableFilters.sync="reportDataFilter"
          :hideColumns="reportDataHideColumn"
          :columnWidth="reportDataColumnWidth"
        />
        <div
          v-if="injectedReportName == ''"
          style="max-width: 420px; text-align: center; font-size: 1.25rem; width: 100%"
        >
          <span> Enter Report Filters and click on <b>Refresh Table</b> to get started</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {
    reportDataColumnWidth: function () {
      if (!this.reportData || this.reportData.length === 0) {
        return [];
      }

      const arrayColumns = Object.keys(this.reportData[0]).filter((f) => !this.reportDataHideColumn.includes(f));

      const numberOfColumns = arrayColumns.length;
      const result = Array.from({ length: numberOfColumns }, () => 150);

      // const operationIndex = arrayColumns.indexOf('Operation');
      const descriptionIndex = arrayColumns.indexOf('Description');
      // result[operationIndex] =
      result[descriptionIndex] = 250;

      return result;
    },
  },
  data: function () {
    return {
      companyName: '',
      companyBranch: '',
      isHQ: false, //whether the current login company is a HQ company
      oriReportType: [
        {
          rpt: "Trial Balance",
          inclThisYear: false,
          inclThisMonth: false,
          inclPrevYear: false,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: false,
          showZeroGLAcc: true,
          showCompareMonth: false,
          rpttype: 'DETAILS',
          key: 'mnuTrial',
          enabled: true,
        },
        {
          rpt: 'Balance Sheet',
          inclThisYear: true,
          inclThisMonth: false,
          inclPrevYear: true,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: false,
          showZeroGLAcc: true,
          showCompareMonth: false,
          rpttype: 'DETAILS',
          key: 'mnuBS',
          enabled: true,
        },
        {
          rpt: 'Balance Sheet - Compare Month By Month',
          inclThisYear: false,
          inclThisMonth: false,
          inclPrevYear: false,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: true,
          showZeroGLAcc: true,
          showCompareMonth: true,
          rpttype: 'DETAILS_MONTH',
          key: 'mnuBS',
          enabled: true,
        },
        {
          rpt: 'Profit & Loss',
          inclThisYear: true,
          inclThisMonth: true,
          inclPrevYear: true,
          inclPrevYearMonth: true,
          showSubAcc: true,
          showPercentage: true,
          showZeroGLAcc: true,
          showCompareMonth: false,
          rpttype: 'DETAILS',
          key: 'mnuPNL',
          enabled: true,
        },
        {
          rpt: 'Profit & Loss - Compare Month By Month',
          inclThisYear: false,
          inclThisMonth: false,
          inclPrevYear: false,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: true,
          showZeroGLAcc: true,
          showCompareMonth: true,
          rpttype: 'DETAILS_MONTH',
          key: 'mnuPNL',
          enabled: true,
        },
        {
          rpt: "HQ Trial Balance",
          inclThisYear: false,
          inclThisMonth: false,
          inclPrevYear: false,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: false,
          showZeroGLAcc: true,
          showCompareMonth: false,
          rpttype: 'DETAILS_COCODE',
          key: 'mnuHQTrial',
          enabled: true,
        },
        {
          rpt: 'HQ Balance Sheet',
          inclThisYear: true,
          inclThisMonth: false,
          inclPrevYear: true,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: false,
          showZeroGLAcc: true,
          showCompareMonth: false,
          rpttype: 'DETAILS_COCODE',
          key: 'mnuHQBS',
          enabled: true,
        },
        {
          rpt: 'HQ Balance Sheet - Compare Month By Month',
          inclThisYear: false,
          inclThisMonth: false,
          inclPrevYear: false,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: true,
          showZeroGLAcc: true,
          showCompareMonth: true,
          rpttype: 'DETAILS_MONTH_COCODE',
          key: 'mnuBS',
          enabled: true,
        },
        {
          rpt: 'HQ Profit & Loss',
          inclThisYear: true,
          inclThisMonth: true,
          inclPrevYear: true,
          inclPrevYearMonth: true,
          showSubAcc: true,
          showPercentage: true,
          showZeroGLAcc: true,
          showCompareMonth: false,
          rpttype: 'DETAILS_COCODE',
          key: 'mnuHQPNL',
          enabled: true,
        },
        {
          rpt: 'HQ Profit & Loss - Compare Month By Month',
          inclThisYear: false,
          inclThisMonth: false,
          inclPrevYear: false,
          inclPrevYearMonth: false,
          showSubAcc: true,
          showPercentage: true,
          showZeroGLAcc: true,
          showCompareMonth: true,
          rpttype: 'DETAILS_MONTH_COCODE',
          key: 'mnuHQPNL',
          enabled: true,
        },
      ],
      reportType: [],
      selectedReport: null,
      SelectedReportErrMsg: '',
      injectedReportName: '',
      injectedFyearPeriod: '',
      injectedMonth: '',
      injectedThisYear: '',
      injectedPreviousYear: '',
      injectedFilters: '',
      departments: [],
      // selectedDepartments: [],

      rptShowInclThisYear: false,
      rptShowInclThisMonth: false,
      rptShowInclPrevYear: false,
      rptShowInclPrevYearMonth: false,
      rptShowSubAcc: false,
      rptShowPercentage: false,
      rptShowZeroGLAcc: false,
      rptShowCompareMonth: false,

      minFYear: '',
      maxFYear: '',
      fYearList: [],
      selectedFYear: null,
      selectedFyearErrMsg: '',
      periodList: [
        { period: '1' },
        { period: '2' },
        { period: '3' },
        { period: '4' },
        { period: '5' },
        { period: '6' },
        { period: '7' },
        { period: '8' },
        { period: '9' },
        { period: '10' },
        { period: '11' },
        { period: '12' },
      ],
      selectedPeriod: null,
      selectedPeriodErrMsg: '',
      periodStartDate: null,
      txnStartDate: null,
      txnEndDate: null,

      inclThisMonth: false,
      inclPrevMonth: false,
      inclPrevYearMonth: false,
      inclPrevYearYTD: false,
      showPercentage: false,
      showSubAcc: false,
      selectedMonthFrom: null,
      selectedMonthFromErrMsg: '',
      selectedMonthTo: null,
      selectedMonthToErrMsg: '',
      showZerolizeFigure: false,

      reportTableName: '',
      reportTableDataType: {},
      reportData: [],
      reportDataFilter: {},
      reportDataHideColumn: ['#', 'PNLSeq', 'BSSeq', 'recordtype'],
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      this.reportType = JSON.parse(JSON.stringify(this.oriReportType));
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FINGL`);
      if (sasControl.length > 0) {
        sasControl.forEach((k) => {
          const selectedReports = this.reportType.filter((f) => f['key'] == k['Control']);
          if (selectedReports.length > 0) {
            selectedReports.forEach((sr) => {
              sr[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
            });
          }
        });
        const mnuTrial = sasControl.find((f) => f['Control'] == 'mnuTrial' && f['PropertiesValue'] == 'False');
        if (mnuTrial) {
          this.reportType = this.reportType.filter((f) => !f['rpt'].includes('Trial'));
        }
        const mnuBS = sasControl.find((f) => f['Control'] == 'mnuBS' && f['PropertiesValue'] == 'False');
        if (mnuBS) {
          this.reportType = this.reportType.filter((f) => !f['rpt'].includes('Balance'));
        }
        const mnuPNL = sasControl.find((f) => f['Control'] == 'mnuPNL' && f['PropertiesValue'] == 'False');
        if (mnuPNL) {
          this.reportType = this.reportType.filter((f) => !f['rpt'].includes('Profit'));
        }
      }
    },
    resetShowUI() {
      this.rptShowInclThisYear = false;
      this.rptShowInclThisMonth = false;
      this.inclThisMonth = false;
      this.inclPrevMonth = false;
      this.rptShowInclPrevYear = false;
      (this.rptShowInclPrevYearMonth = false), (this.inclPrevYearMonth = false);
      this.inclPrevYearYTD = false;
      this.rptShowSubAcc = false;
      this.showSubAcc = false;
      this.rptShowPercentage = false;
      this.showPercentage = false;
      this.rptShowZeroGLAcc = false;
      this.showZerolizeFigure = false;
      this.rptShowCompareMonth = false;
      this.selectedMonthFrom = null;
      this.selectedMonthTo = null;
      this.resetInjected();
      this.resetErrMsg();
    },
    resetInjected() {
      this.injectedReportName = '';
      this.injectedFyearPeriod = '';
      this.injectedMonth = '';
      this.injectedThisYear = '';
      this.injectedPreviousYear = '';
      this.injectedFilters = '';
      this.reportData = [];
    },
    resetErrMsg() {
      this.SelectedReportErrMsg = '';
      this.selectedFyearErrMsg = '';
      this.selectedPeriodErrMsg = '';
      this.selectedMonthFromErrMsg = '';
      this.selectedMonthToErrMsg = '';
    },
    reportSelected(selected, oldSelected) {
      if (selected) {
        if (oldSelected && selected['rpt'] == oldSelected['rpt']) {
          return;
        }
        this.resetShowUI();

        if (selected['inclThisYear'] == true) {
          this.rptShowInclThisYear = true;
          if (selected['inclThisMonth'] == true) {
            this.rptShowInclThisMonth = true;
          }
        }
        if (selected['inclPrevYear'] == true) {
          this.rptShowInclPrevYear = true;
          if (selected['inclPrevYearMonth'] == true) {
            this.rptShowInclPrevYearMonth = true;
          }
        }
        if (selected['showSubAcc'] == true) {
          this.rptShowSubAcc = true;
        }
        if (selected['showPercentage'] == true) {
          this.rptShowPercentage = true;
        }
        if (selected['showZeroGLAcc'] == true) {
          this.rptShowZeroGLAcc = true;
        }
        if (selected['showCompareMonth'] == true) {
          this.rptShowCompareMonth = true;
        }
        this.reportTableName = selected['rpt'];
      } else {
        this.resetShowUI();
      }
    },
    inclThisMonthClicked(state) {
      if (!state) {
        this.inclPrevMonth = false;
        this.inclPrevYearMonth = false;
      }
    },
    fYearSelected(selected) {
      if (selected) {
        this.setTxnStartDate(selected['fyear']);
        if (this.selectedPeriod) {
          this.setTxnEndDate(selected['fyear'], this.selectedPeriod['period']);
        }
      }
    },
    async periodSelected(selected) {
      if (this.selectedFYear && selected) {
        this.setTxnEndDate(this.selectedFYear['fyear'], selected['period']);
        if (selected['period'] == '1') {
          this.inclThisMonth = false;
          this.inclPrevYearMonth = false;
        }
        const periodStartDate = await this.getPeriodStartDate(this.selectedFYear['fyear'], this.selectedPeriod['period']);
        this.periodStartDate = new Date(periodStartDate);
      }
    },
    validateFilterCheck() {
      let validateError = false;

      if (!this.selectedReport) {
        validateError = true;
        this.SelectedReportErrMsg = 'Report Type is required!';
      }

      if (!this.selectedFYear) {
        validateError = true;
        this.selectedFyearErrMsg = 'FYear is required!';
      }

      if (!this.rptShowCompareMonth && !this.selectedPeriod) {
        validateError = true;
        this.selectedPeriodErrMsg = 'Period is required!';
      }

      if (this.rptShowCompareMonth) {
        if (!this.selectedMonthFrom) {
          validateError = true;
          this.selectedMonthFromErrMsg = 'From is required!';
        }
        if (!this.selectedMonthTo) {
          validateError = true;
          this.selectedMonthToErrMsg = 'To is required!';
        }
      }

      return validateError;
    },
    async refreshClicked() {
      this.resetErrMsg();
      if (this.validateFilterCheck() == true) {
        return;
      }

      this.resetInjected();
      this.injectedReportName = this.selectedReport['rpt'];
      if (this.rptShowCompareMonth) {
        this.injectedMonth = `${this.selectedFYear['fyear']} - ${this.selectedMonthFrom['period']} to ${this.selectedMonthTo['period']}`;
      } else {
        this.injectedFyearPeriod = `${this.selectedFYear['fyear']} - ${this.selectedPeriod['period']}`;
      }
      if (this.inclThisMonth) {
        this.injectedThisYear = `This Month ${this.inclPrevMonth ? ' and previous month' : ''}`;
      }
      if (this.inclPrevYearMonth || this.inclPrevYearYTD) {
        this.injectedPreviousYear = `${this.inclPrevYearMonth ? 'This Month' : ''}${this.inclPrevYearMonth ? ' and ' : ''}${this.inclPrevYearYTD ? 'YTD' : ''}`;
      }
      if (this.showSubAcc || this.showPercentage || this.showZerolizeFigure) {
        const tempFilters = `${this.showSubAcc ? ', Sub Account' : ''}${this.showPercentage ? ', Percentage' : ''}${this.showZerolizeFigure ? 'GL Accounts with Zero Amounts' : ''}`;
        this.injectedFilters = `Show ${tempFilters.substring(1)}`;
      }
      if (this.selectedReport['rpt'].includes('Profit')) {
        //profit and loss
        await this.getProfitAndLossReportData();
      } else if (this.selectedReport['rpt'].includes('Trial')) {
        //trial balance
        await this.getTrialBalanceReportData();
      } else {
        //balance Sheet
        await this.getBalanceSheetReportData();
      }
    },
    getDataFilter() {
      this.reportDataFilter = {};
      const newDataFilter = {};
      newDataFilter['Company'] = `${this.companyName}(${this.companyBranch})`;
      newDataFilter['Report Name'] = this.selectedReport['rpt'];
      newDataFilter['Print Date Time'] = new Date().formatString(
        `${this.$store.state['preferredDateFormat']} HH:mm:ss`,
      );
      if (this.rptShowCompareMonth) {
        newDataFilter['FYear - Month From To'] =
          `${this.selectedFYear['fyear']} - ${this.selectedMonthFrom['period']} to ${this.selectedMonthTo['period']}`;
      } else {
        newDataFilter['FYear - Period'] = `${this.selectedFYear['fyear']} - ${this.selectedPeriod['period']}`;
        const txnStartDateTemp = this.selectedReport['rpt'].includes('Trial') ? this.periodStartDate : this.txnStartDate;
        newDataFilter['Transaction Date From'] = txnStartDateTemp.formatString(
          this.$store.state['preferredDateFormat'],
        );
        newDataFilter['Transaction Date To'] = this.txnEndDate.formatString(this.$store.state['preferredDateFormat']);
      }
      if (this.inclThisMonth) {
        newDataFilter['Include This Month'] =
          `${this.txnEndDate.formatString('yyyy-MM')}${this.inclPrevMonth ? ' and previous month' : ''}`;
      }
      if (this.inclPrevYearMonth) {
        newDataFilter['Include Previous Year This Month'] = 'Included';
      }
      if (this.inclPrevYearYTD) {
        newDataFilter['Include Previous Year YTD'] = 'Included';
      }
      if (this.showSubAcc) {
        newDataFilter['Show Sub Account'] = 'Show';
      }
      this.reportDataFilter = newDataFilter;
    },
    async getTrialBalanceReportData() {
      this.reportData = [];
      this.getDataFilter();

      const postBody = {
        hqconsol: this.selectedReport['rpt'].includes('HQ') ? '1' : '0',
        fyear: this.selectedFYear['fyear'],
        startdate: this.periodStartDate.formatString('yyyy-MM-dd'), //period start date
        enddate: this.txnEndDate.formatString('yyyy-MM-dd'),
        rpttype: this.selectedReport['rpttype'],
        showsubacc: this.showSubAcc ? '1' : '0',
        showzerofigure: this.showZerolizeFigure ? '1' : '0',
      };
      this.$fullscreenLoading('Getting Trial Balance Report');
      const tempReportData = await this.$apiCallV2('/FINGLReport/GetTrialBalanceReport', postBody, null, null, false);
      this.reportTableDataType = tempReportData[0];
      this.reportData = tempReportData;
      this.$fullscreenLoading('');
    },
    async getBalanceSheetReportData() {
      this.reportData = [];
      this.getDataFilter();

      let startMonthDate = '';
      let endMonthDate = '';
      if (this.rptShowCompareMonth) {
        startMonthDate = await this.getPeriodStartDate(this.selectedFYear['fyear'], this.selectedMonthFrom['period']);
        endMonthDate = await this.getPeriodEndDate(this.selectedFYear['fyear'], this.selectedMonthTo['period']);
      }

      const postBody = {
        hqconsol: this.selectedReport['rpt'].includes('HQ') ? '1' : '0',
        startdate: startMonthDate != '' ? startMonthDate : this.txnStartDate.formatString('yyyy-MM-dd'),
        enddate: endMonthDate != '' ? endMonthDate : this.txnEndDate.formatString('yyyy-MM-dd'),
        rpttype: this.selectedReport['rpttype'],
        inclprevmonth: this.inclPrevMonth ? '1' : '0',
        thismonthstartdate: this.inclPrevMonth ? `${this.txnEndDate.formatString('yyyy-MM')}-01` : '', //set to 1st day
        inclprevyearytd: this.inclPrevYearYTD ? '1' : '0',
        comparemonth: this.rptShowCompareMonth ? '1' : '0',
        showacc: '1',
        showsubacc: this.showSubAcc ? '1' : '0',
        showzerofigure: this.showZerolizeFigure ? '1' : '0',
      };
      this.$fullscreenLoading('Getting Balance Sheet Report');
      const tempReportData = await this.$apiCallV2('/FINGLReport/GetBalanceSheetReport', postBody, null, null, false);
      this.reportTableDataType = tempReportData[0];
      this.reportData = tempReportData;
      this.$fullscreenLoading('');
    },
    async getProfitAndLossReportData() {
      this.reportData = [];
      this.getDataFilter();

      let startMonthDate = '';
      let endMonthDate = '';
      if (this.rptShowCompareMonth) {
        startMonthDate = await this.getPeriodStartDate(this.selectedFYear['fyear'], this.selectedMonthFrom['period']);
        endMonthDate = await this.getPeriodEndDate(this.selectedFYear['fyear'], this.selectedMonthTo['period']);
      }

      const postBody = {
        hqconsol: this.selectedReport['rpt'].includes('HQ') ? '1' : '0',
        startdate: startMonthDate != '' ? startMonthDate : this.txnStartDate.formatString('yyyy-MM-dd'),
        enddate: endMonthDate != '' ? endMonthDate : this.txnEndDate.formatString('yyyy-MM-dd'),
        rpttype: this.selectedReport['rpttype'],
        inclthismonth: this.inclThisMonth ? `${this.txnEndDate.formatString('yyyy-MM')}-01` : '', //set to 1st day
        inclprevmonth: this.inclPrevMonth ? '1' : '0',
        inclprevyearthismonth: this.inclPrevYearMonth ? '1' : '0',
        inclprevyearytd: this.inclPrevYearYTD ? '1' : '0',
        comparemonth: this.rptShowCompareMonth ? '1' : '0',
        showacc: '1',
        showsubacc: this.showSubAcc ? '1' : '0',
        showzerofigure: this.showZerolizeFigure ? '1' : '0',
      };
      this.$fullscreenLoading('Getting Profit And Loss Report');
      const tempReportData = await this.$apiCallV2('/FINGLReport/GetProfitAndLossReport', postBody, null, null, false);
      this.reportTableDataType = tempReportData[0];
      this.reportData = tempReportData;
      this.$fullscreenLoading('');
    },
    async getFYearStartDate(fyear) {
      this.$fullscreenLoading('Getting Start Period Date');
      const tempResult = (
        await this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'FYEARSTARTDATE', fyear: fyear })
      )[0]['fyearstartdate'];
      this.$fullscreenLoading();
      return tempResult;
    },
    async getPeriodStartDate(fyear, period) {
      this.$fullscreenLoading('Getting Start Period Date');
      const periodEndDate = (
        await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
          masterfile: 'FYEARPERIODSTARTDATE',
          fyear: fyear,
          period: period,
        })
      )[0]['fyearstartdate'];
      this.$fullscreenLoading();
      return periodEndDate;
    },
    async getPeriodEndDate(fyear, period) {
      this.$fullscreenLoading('Getting End Period Date');
      const periodEndDate = (
        await this.$apiCallV2('/FINGLJournal/GetFINGLList', {
          masterfile: 'FYEARPERIODENDDATE',
          fyear: fyear,
          period: period,
        })
      )[0]['fyearstartdate'];
      this.$fullscreenLoading();
      return periodEndDate;
    },
    async setTxnStartDate(fyear) {
      const fYearStartDate = await this.getFYearStartDate(fyear);
      this.txnStartDate = new Date(fYearStartDate);
    },
    async setTxnEndDate(fyear, period) {
      const periodEndDate = await this.getPeriodEndDate(fyear, period);
      this.txnEndDate = new Date(periodEndDate);
    },
  },
  async mounted() {
    await this.sasControlFunction();
    const loginDetails = await this.$apiCallV2('/Login/GetDetails');
    this.companyName = loginDetails['CoName'];
    this.companyBranch = loginDetails['Branch']['BrName'];

    const finglReportPromises = [];
    let promisesFulfilled = 0;
    this.$fullscreenLoading('Loading Data');

    finglReportPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PARENTCOMPANYBRANCH' }).then((result) => {
        if (result.length > 1) {
          this.isHQ = true; //to show dropdown with HQ option
        } else {
          this.reportType = JSON.parse(JSON.stringify(this.reportType.filter((f) => !f['rpt'].includes('HQ'))));
        }
        this.$topLoading(++promisesFulfilled / finglReportPromises.length);
      }),
    );

    finglReportPromises.push(
      this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'GLCOSTDEPT' }).then((result) => {
        this.departments = result;
        this.$topLoading(++promisesFulfilled / finglReportPromises.length);
      }),
    );

    finglReportPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=FINGL_MinYrGenNewYr').then((result) => {
        this.minFYear = result[0].SettingsValue;
        this.$topLoading(++promisesFulfilled / finglReportPromises.length);
      }),
    );

    finglReportPromises.push(
      this.$apiCallV2('/FINGLJournal/GetFINGLList', { masterfile: 'LATESTFYEAR' }).then((result) => {
        this.maxFYear = result[0].fYear;
        this.$topLoading(++promisesFulfilled / finglReportPromises.length);
      }),
    );

    await Promise.allSettled(finglReportPromises).then((_promiseOutcomes) => {
      if (this.minFYear && this.maxFYear) {
        for (let year = this.maxFYear; year >= this.minFYear; year--) {
          this.fYearList.push({ fyear: String(year) });
        }
      }
    });

    this.$fullscreenLoading('');
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.finGLReport-main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 5px 10px 45px;
  display: flex;
  overflow: hidden;

  .content-container {
    display: flex;
    width: 100%;
    gap: 4px;
  }

  .left-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;
    resize: horizontal;
    overflow: auto;
    width: 280px;
    min-width: 170px;
    max-width: 30%;
  }

  .filter-container {
    border-radius: 4px;
    padding: 8px;
    padding-top: 4px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 2px;
    position: relative;
    min-height: 0;
  }

  .filter-options {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
    overflow: auto;
  }

  .table-container {
    min-height: 0;
    flex-grow: 1;
    padding: 8px;
    padding-top: 0px;
    background-color: white;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
  }
}
</style>
